import { useContext } from 'react'; 
import PageContext from './PageContext'; 
import moneyFormat from '../functions/moneyFormat';
import RowEditIcon from './RowEditIcon';
import greenCircleIcon from '../../svgs/green-circle-icon.svg';
import redCircleIcon from '../../svgs/red-circle-icon.svg';
import { TableCell } from '@mui/material';

// pass row object as prop 
const AdhocDataRow = ({ row, count, tableHeader, editBool,stickyEnabled }) =>{
    // initialize PageContext from parent
    const {
        setShowEditAdhocModal, 
        setEditAdhocRow, 
        setShowMarkPaymentFailedModal, 
        setMarkPaymentFailedRow, 
    } = useContext(PageContext); 

    // event handler for edit click
    const onEditClick = () => {
        setEditAdhocRow(editAdhocRow => editAdhocRow = row); 
        setShowEditAdhocModal(showEditAdhocModal => showEditAdhocModal = true); 
    }

    // event handler for mark failed click 
    const onMarkFailedClick = () => {
        setMarkPaymentFailedRow(markPaymentFailedRow => markPaymentFailedRow = row); 
        setShowMarkPaymentFailedModal(showMarkPaymentFailedModal => showMarkPaymentFailedModal = true); 
    }

    // display red circle for disabled (0) status or green circle for active (1) status
    const statusIcon = (status) =>{
        if ( status == true){
            return <img src={greenCircleIcon} class='data-table-icon-left'/>
        }
        else {
            return <img src={redCircleIcon} class='data-table-icon-left'/>
        }
    }

    const getRowClassName = (columnOrder) =>{
        // Pass sticky row class if columnOrder is 0 i.e first column and stickyEnabled Prop is true
        return stickyEnabled && columnOrder===0 ? "table-cell-sticky-row": ""
    }

    return(
        <>
            {/* map logic over all columns in object */}
            {tableHeader.map(el => 
                // apply money format to correct columns  
                el['columnname'] == 'amount' ?
                    row[el['columnname']] == null ?
                    <TableCell className={getRowClassName(el['columnorder'])} align='right'>None</TableCell>
                    :<TableCell className={getRowClassName(el['columnorder'])} align='right'>{moneyFormat(row[el['columnname']])}</TableCell>
                // display for companyid
                : el['columnname'] == 'companyid' ? 
                    row[el['columnname']] == process.env.REACT_APP_MASTER_PAYOUT_INFO_PLACEHOLDER ?
                    <TableCell className={getRowClassName(el['columnorder'])}>MASTER</TableCell>
                    :<TableCell className={getRowClassName(el['columnorder'])}>{row[el['columnname']]}</TableCell> 
                // display for blank column. Show edit if row has not been transmitted yet
                : el['columnname'] == 'blank' ?
                    // // edit adhoc payments before they are transferred
                    // row['transmitted'] == false && row['paymenttypeid'] == process.env.REACT_APP_PAYMENT_TYPE_ID ? 
                    //     <TableCell className={getRowClassName(el['columnorder'])}>
                    //         {/* show edit icon to trigger edit modal */}                      
                    //         <RowEditIcon enable={editBool} onClick={onEditClick}/>
                    //     </TableCell>
                    // // mark any transferred payments as failed
                    // : row['transmitted'] == true && process.env.REACT_APP_MARK_PAYMENT_FAILED == '1'? 
                    row['transmitted'] == true && process.env.REACT_APP_MARK_PAYMENT_FAILED == '1'? 
                        <TableCell className={getRowClassName(el['columnorder'])}>
                            {/*show edit icon to trigger MarkPaymentFailedModal */}
                            <RowEditIcon enable={editBool} onClick={onMarkFailedClick} />
                        </TableCell>
                    :<TableCell className={getRowClassName(el['columnorder'])}></TableCell> 
                // display for status column 
                : el['columnname'] == 'active' ?
                    <TableCell className={getRowClassName(el['columnorder'])}>{statusIcon(row[el['columnname']])}</TableCell>
                // standard display for all other columns 
                : row[el['columnname']] == null ?
                    <TableCell className={getRowClassName(el['columnorder'])}>None</TableCell>
                // standard display for all other columns 
                :<TableCell className={getRowClassName(el['columnorder'])}>{row[el['columnname']]}</TableCell>          
            )}
        </>
    );
}

export default AdhocDataRow; 